'use client';
import { usePermission } from '@benzinga/user-context';

export const TabPaywall = () => {
  const hasAccess = usePermission('com/read', 'unlimited-articles');

  return (
    <>
      {!hasAccess ? (
        <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-50 z-50 flex flex-col items-center justify-center gap-4 backdrop-blur-md">
          <h3 className="font-bold text-3xl">Stock Score Locked: Want to See it?</h3>
          <p className="text-center">Benzinga Rankings give you vital metrics on any stock - anytime.</p>
          <a
            href="https://www.benzinga.com/premium/ideas/benzinga-edge/?utm_campaign=commandcenter&adType=mystocks&ad=fullscore"
            target="_blank"
            className="bg-bzblue-700 text-white rounded-md p-2 hover:bg-bzblue-800 transition-colors"
          >
            Reveal Full Score
          </a>
        </div>
      ) : null}
  </>
  );
};    
